exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reg-modal-container[data-v-f4fb30e4]{background-color:#e9e9e9;border:1px solid #aeaeae;border-radius:3px;overflow:hidden;padding:32px 0}.btn-close[data-v-f4fb30e4]{position:absolute;top:12px;right:12px;font-size:20px;color:#777}.btn-close[data-v-f4fb30e4]:hover{color:#ff5722}", ""]);

// exports
